import React from 'react'
import LineAngleRightIcon from 'LuxKit/Icons/line/LineAngleRightIcon'
import AssistChip from 'LuxKit/Chips/AssistChip'

interface Props {
  label: string
  to: string
}

function LuxPlusLandingProductPillLink({ label, to }: Props) {
  return (
    <AssistChip
      variant="filled"
      size="small"
      to={to}
      endIcon={<LineAngleRightIcon size="XS" />}
    >
      {label}
    </AssistChip>
  )
}

export default LuxPlusLandingProductPillLink
